export default __webpack_public_path__ + "img/jtc/jtc_logo.svg";